import { useTranslation } from 'react-i18next';

export default function CouponSection() {
  const { t } = useTranslation();

  const coupons = [
    { code: 'CSSBUY2026', discount: '10% Off', type: 'Service Fee', expiry: 'Dec 2026' },
    { code: 'SHIPFREE50', discount: 'Free Shipping', type: 'Orders $50+', expiry: 'Sep 2026' },
    { code: 'NEWUSER15', discount: '15% Off', type: 'First Order', expiry: 'Limited' },
  ];

  return (
    <section id="coupon" className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="order-2 lg:order-1">
            <span className="text-sm font-medium text-primary-600 uppercase tracking-widest mb-2 block">
              Coupons
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mb-4">
              {t('coupon_title')}
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-6">
              {t('coupon_desc')}
            </p>
            <div className="space-y-3">
              {coupons.map((coupon) => (
                <div key={coupon.code} className="flex items-center justify-between p-4 bg-background-50 rounded-lg border border-dashed border-primary-300/50">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-md bg-primary-50 flex items-center justify-center">
                      <i className="ri-coupon-3-line w-5 h-5 flex items-center justify-center text-primary-600" />
                    </div>
                    <div>
                      <div className="font-mono text-sm font-semibold text-foreground-900">{coupon.code}</div>
                      <div className="text-xs text-foreground-500">{coupon.type} · Expires {coupon.expiry}</div>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="font-heading text-lg font-bold text-primary-600">{coupon.discount}</div>
                  </div>
                </div>
              ))}
            </div>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors mt-4"
            >
              View All Coupons
              <i className="ri-external-link-line w-4 h-4 flex items-center justify-center" />
            </a>
          </div>
          <div className="relative order-1 lg:order-2">
            <div className="aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=discount%20coupon%20ticket%20and%20price%20reduction%20tag%20with%20scissors%20on%20clean%20white%20surface%20studio%20product%20photography%20soft%20light%20minimal%20promotion&width=800&height=600&seq=coupon-1&orientation=landscape&nocache=true"
                alt="Coupons"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}